import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/filter-chip/filter-chip.js';
      import {ObcFilterChipChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/filter-chip/filter-chip.js';

      export interface Props {
     disabled?: boolean;
     label?: string;
     checked?: boolean;
     showIcon?: boolean
   }

      
  
      export type {ObcFilterChipChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/filter-chip/filter-chip.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcFilterChip',
  props: {
    disabled: { type: Boolean },
    label: {},
    checked: { type: Boolean },
    showIcon: { type: Boolean }
  },
  emits: ["chip-toggle"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChipToggle: (event: ObcFilterChipChangeEvent) => emit('chip-toggle', event as ObcFilterChipChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-filter-chip',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})